import "../../css/components/SocialWidget.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Text from "./Text";
import Social from "../../js/components/Social";
import g from "../utils/globals";

class SocialWidget extends Component {
  constructor(props) {
    super(props);
    this.el = null;
    this.sharingMethods = ["facebook", "twitter", "pinterest"];
    this.sharingConfig = {
      media: props.media || `${g.imageDir}/mkt/spots/ss19-sales/close-page/${g.localeEdge}_1_1_0.jpg`,
      url: this.props.targetUrl || `${window.location.protocol}//${window.location.host}/`,
      description: this.props.content,
    };
  }

  componentDidMount = () => {
    window.addEventListener("click", this.stopPropagationBubble, true);
  };

  componentWillUnmount = () => {
    window.removeEventListener("click", this.stopPropagationBubble, true);
  };

  stopPropagationBubble = e => {
    if (e.target.classList.contains("socialwidget-component")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.handleShareClick();
    }
  };

  handleShareMouseOver = () => this.el.children[1].classList.remove("hide");

  handleShareClick = () => {
    if (g.isTablet) {
      this.el.children[1].classList.remove("hide");
    }
  };

  handleShareMouseOut = () => this.el.children[1].classList.add("hide");

  render = () => (
    <div
      className="hashtag-wrapper sales"
      onMouseOver={this.handleShareMouseOver}
      onMouseOut={this.handleShareMouseOut}
      onClick={this.handleShareClick}
      ref={el => {
        this.el = el;
      }}
    >
      <Text {...this.props} />
      <ul className="socialLinks hide">
        {this.sharingMethods.map((x, i) => (
          <li key={i}>
            <Social social={x} styles={this.props.styles} {...this.sharingConfig} />
          </li>
        ))}
      </ul>
    </div>
  );
}

SocialWidget.defaultProps = {
  attributes: {},
  content: "",
  media: "",
  attrs: {},
  styles: {},
};

SocialWidget.propTypes = {
  attributes: PropTypes.object,
  content: PropTypes.string.isRequired,
  media: PropTypes.string,
  attrs: PropTypes.object,
  styles: PropTypes.object,
};

export default SocialWidget;
